import type { ResponseType, Role } from '@/types/common';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = '/api/v1';

export const roleApi = {
  /**
   * @description 获取所有角色列表
   */
  getAll(): ResponseType<Role[]> {
    return request({
      method: 'GET',
      url: `${prefix}/allRoles`,
    });
  },

  /**
   * @description 获取所有角色列表（免权限）
   */
  getAllRoles(): ResponseType<Role[]> {
    return request({
      method: 'GET',
      url: `${prefix}/queryRole`,
    });
  },
};
